import React from "react"
import { Grid, Typography, withStyles } from "@material-ui/core"
import ItemsWithCheckMark from "../../../../Common/ItemsWithCheckMark"

const WhatYouWillLearn = ({ label, items }) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant={"h6"}>{label}</Typography>
      </Grid>
      <Grid item xs={12} md={7}>
        <ItemsWithCheckMark items={items} />
      </Grid>
    </Grid>
  )
}

const styles = theme => ({})

export default withStyles(styles)(WhatYouWillLearn)
